import { render, staticRenderFns } from "./PlanContainer.vue?vue&type=template&id=0632faf5"
import script from "./PlanContainer.vue?vue&type=script&lang=js"
export * from "./PlanContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports